import { Organization } from "@/types/match"
import { OrganizationSchema } from "@/types/match"
import { fetchApi } from "~/lib/api-client"

export async function verifyAuthCode(code: string): Promise<Organization | null> {
  const response = await fetchApi(`/organizations/verify?code=${code}`, OrganizationSchema, {
    method: "GET",
  })
  return response
}

